<script setup lang="ts">
const props = defineProps({
  width: {
    type: String,
    default: '100%'
  },
  height: {
    type: String,
    default: '100%'
  },
  customClass: {
    type: String,
    default: ''
  }
})
</script>
<template>
  <div class="skeleton" :class="customClass" :style="{ width: props.width, height: props.height }"></div>
</template>
<style lang="scss" scoped>
@import '~scssAsset/components/common/skeleton.scss';
</style>
